import Swiper from 'swiper';
import { add_swiper_class } from '@sanctuairedelisi/js/tools/swiper';

export default class Slider {
    
    constructor()
    {
        Slider.hero();
        Slider.entity();
        Slider.messes();
    }
    
    static hero( options )
    {
        const slider         = '[data-id="wpiris-hero-slider"]',
              slider_wrapper = '[data-id="wpiris-hero-slider-wrapper"]',
              slider_item    = '[data-id="wpiris-hero-slider-item"]';
        
        let swiper = {};
        
        if ( $( slider ).length > 0 ) {
            
            add_swiper_class( $( slider ), $( slider_wrapper ), $( slider_item ) );
            
            $( '.bannerMedia' ).append( '<div class="bannerArrow bannerArrow--prev swiperArrow swiperArrow--prev"></div><div class="bannerArrow bannerArrow--next swiperArrow swiperArrow--next"></div>' );
    
            const default_options_hero = {
                mousewheel: {
                    forceToAxis: true,
                },
                autoplay: {
                    delay: 5000
                },
                speed: 600,
                slidesPerView: 1,
                lazy: true,
                navigation: {
                    nextEl: '.bannerArrow--next',
                    prevEl: '.bannerArrow--prev',
                },
            };
    
            const swiper_options = Object.assign( {}, default_options_hero, options );
            
            swiper = new Swiper( $( slider ), swiper_options );
        }
        
        return swiper;
    }
    
    static entity( options = {} )
    {
        const slider = '[data-id="wpiris-default-slider"]';
        
        $( slider ).each( function () {
            
            let slider_wrapper     = $( this ).find( '[data-id="wpiris-default-slider-wrapper"]' );
            let slider_item        = $( this ).find( '[data-id="wpiris-default-slider-item"]' );
            let slider_button_prev = $( this ).find( '[data-id="wpiris-default-slider-button-prev"]' );
            let slider_button_next = $( this ).find( '[data-id="wpiris-default-slider-button-next"]' );
            
            add_swiper_class( $( this ), slider_wrapper, slider_item, slider_button_prev, slider_button_next );
            
            const default_options = {
                slidesPerView: 1,
                spaceBetween: 16,
                init: false,
                lazy: true,
                navigation: {
                    nextEl: '.entityArrow--next',
                    prevEl: '.entityArrow--prev',
                },
                breakpoints: {
                    370: {
                        slidesPerView: 2,
                        spaceBetween: 16
                    },
                    651: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    1001: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1300: {
                        slidesPerView: 3,
                        spaceBetween: 40
                    }
                },
            };
            
            const swiper_options = Object.assign( {}, default_options, options );
            
            const swiper = new Swiper( $( this ), swiper_options );
            
            swiper.on( 'init resize', function () {
                Slider.toggle_arrows( this );
            } );
            
            swiper.init();
            
        } );
    }
    
    static toggle_arrows( swiper )
    {
        const prevEl = $( swiper.navigation.prevEl );
        const nextEl = $( swiper.navigation.nextEl );
        if ( prevEl.hasClass( 'swiper-button-disabled' ) && nextEl.hasClass( 'swiper-button-disabled' ) ) {
            $( swiper.navigation.prevEl ).hide();
            $( swiper.navigation.nextEl ).hide();
        } else {
            $( swiper.navigation.prevEl ).show();
            $( swiper.navigation.nextEl ).show();
        }
    }
    
    static messes( options = {} )
    {
        const slider = '[data-id="wpiris-messes-slider"]';
        
        $( slider ).each( function () {
            
            let slider_wrapper = $( this ).find( '[data-id="wpiris-messes-slider-wrapper"]' ),
                slider_item    = $( this ).find( '[data-id="wpiris-messes-slider-item"]' );
            
            add_swiper_class( $( slider ), slider_wrapper, slider_item );
            
            const default_options = {
                init: false,
                freeMode: true,
                slidesPerView: 'auto',
                spaceBetween: 10,
                lazy: true,
                breakpoints: {
                    651: {
                        spaceBetween: 20
                    },
                    1300: {
                        spaceBetween: 40
                    }
                }
            };
            
            const swiper_options = Object.assign( {}, default_options, options );
            
            const swiper = new Swiper( $( this ), swiper_options );
            
            swiper.on( 'init resize', function () {
                Slider.toggle_arrows( this );
            } );
            
            swiper.init();
            
        } );
    }
    
    static about()
    {
        const navigation_slider = '#wpiris-about-navigation-slider';
        const slider            = '#wpiris-about-slider';
        
        if ( navigation_slider.length > 0 && slider.length > 0 ) {
            
            let navigation_slider_wrapper = $( navigation_slider ).find( '[data-id="wpiris-about-navigation-slider-wrapper"]' ),
                navigation_slider_item    = $( navigation_slider ).find( '[data-id="wpiris-about-navigation-slider-item"]' );
            
            add_swiper_class( $( navigation_slider ), navigation_slider_wrapper, navigation_slider_item );
            
            let navigation_swiper = Slider.about_navigation_swiper = new Swiper( navigation_slider, {
                slidesPerView: 2,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                allowTouchMove: false,
                autoplay: {
                    delay: 3000
                },
                pauseOnMouseEnter: true,
            } );
            
            let slider_wrapper = $( slider ).find( '[data-id="wpiris-about-slider-wrapper"]' ),
                slider_item    = $( slider ).find( '[data-id="wpiris-about-slider-item"]' );
            
            if ( $( '.aboutArrow--prev' ).length == 0 && $( '.aboutArrow--next' ).length == 0 ) {
                $( '<div class="aboutArrow aboutArrow--prev swiperArrow swiperArrow--prev"></div><div class="aboutArrow aboutArrow--next swiperArrow swiperArrow--next"></div>' ).insertAfter( slider );
            }
            
            add_swiper_class( $( slider ), slider_wrapper, slider_item );
            
            Slider.about_slider_swiper = new Swiper( slider, {
                slidesPerView: 1,
                autoplay: {
                    delay: 3000
                },
                effect: 'fade',
                pauseOnMouseEnter: true,
                navigation: {
                    prevEl: '.aboutArrow--prev',
                    nextEl: '.aboutArrow--next'
                },
                thumbs: {
                    swiper: navigation_swiper
                }
            } );
        }
    }
    
    static agenda()
    {
        const agenda_slider = '#wpiris-agenda-slider';
        
        if ( agenda_slider.length > 0 ) {
            
            let agenda_slider_wrapper = $( agenda_slider ).find( '[data-id="wpiris-agenda-slider-wrapper"]' ),
                agenda_slider_item    = $( agenda_slider ).find( '[data-id="wpiris-agenda-slider-item"]' );
            
            add_swiper_class( $( agenda_slider ), agenda_slider_wrapper, agenda_slider_item );
            
            const agenda_swiper = new Swiper( agenda_slider, {
                slidesPerView: 1,
                spaceBetween: 20,
                init: false,
                navigation: {
                    prevEl: '.agendaArrowsItem--prev',
                    nextEl: '.agendaArrowsItem--next'
                },
                breakpoints: {
                    651: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1001: {
                        slidesPerView: 2,
                        spaceBetween: 40
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1300: {
                        slidesPerView: 3,
                        spaceBetween: 40
                    }
                },
            } );
            
            agenda_swiper.on( 'init resize', function () {
                Slider.toggle_arrows( this );
            } );
            
            agenda_swiper.init();
        }
    }
    
    static le_sanctuaire()
    {
        const slider = $( '#wpiris-le-sanctuaire-slider' );
        
        if ( slider.length > 0 ) {
            
            let slider_wrapper = $( slider ).find( '[data-id="wpiris-le-sanctuaire-slider-wrapper"]' ),
                slider_item    = $( slider ).find( '[data-id="wpiris-le-sanctuaire-slider-item"]' );
            
            if ( $( '.le-sanctuaireArrow--prev' ).length == 0 && $( '.le-sanctuaireArrow--next' ).length == 0 ) {
                const arrow_dom = `<div class="le-sanctuaireArrows">
                       <div class="le-sanctuaireArrowsItem le-sanctuaireArrowsItem--prev swiperArrow swiperArrow--prev"></div>
                       <div class="le-sanctuaireArrowsItem le-sanctuaireArrowsItem--next swiperArrow swiperArrow--next"></div>
                   </div>`;
                $( arrow_dom ).insertAfter( slider );
            }
            
            add_swiper_class( $( slider ), slider_wrapper, slider_item );
            
            const swiper = new Swiper( slider, {
                slidesPerView: 1,
                spaceBetween: 16,
                navigation: {
                    prevEl: '.le-sanctuaireArrowsItem--prev',
                    nextEl: '.le-sanctuaireArrowsItem--next'
                },
                breakpoints: {
                    370: {
                        slidesPerView: 2
                    }
                }
            } );
        }
    }
}